// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CalendarService } from '../../services/calendar.service';
declare var bootstrap: any; // Import Bootstrap globally

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css'],
  standalone: false
})
export class CalendarComponent implements OnInit, AfterViewInit {
  @Output('onCellClick') onCellClick: EventEmitter<any> = new EventEmitter<any>();

  month: string = 'May';
  year: number = 2025;
  days: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  calendar: (number | null)[][] = [];
  googleCalendarLink!: string;
  icsFileLink!: string;
  outlookCalendarLink!: string;
  deviceType!: string;


  constructor(private calendarService: CalendarService) {
    this.googleCalendarLink = this.calendarService.getGoogleCalendarLink();
    this.icsFileLink = this.calendarService.getICSFileLink();
    this.outlookCalendarLink = this.calendarService.getOutlookCalendarLink();
    this.deviceType = this.calendarService.detectDevice();
  }
  ngOnInit() {
    this.generateCalendar();
  }

  ngAfterViewInit(): void {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach(tooltip => new bootstrap.Tooltip(tooltip));
  }

  generateCalendar() {
    const daysInMonth = 31;
    let dayCounter = 1;
    let tempWeek = new Array(7).fill(null);
    this.calendar = [];

    for (let i = 0; i < 5; i++) {
      let week: (number | null)[] = new Array(7).fill(null);
      for (let j = 0; j < 7; j++) {
        if (i === 0 && j < 4) continue; // Skip empty days at start
        if (dayCounter <= daysInMonth) {
          week[j] = dayCounter++;
        }
      }
      this.calendar.push(week);
    }
  }

  cellClicked() {
    this.onCellClick.emit('clicked');
  }
  triggerConfetti() {
    // Placeholder for confetti effect
  }
}
